import React, { useContext, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { getDisplayName } from 'Utils/PureHelperFuctions'
import useAppView from 'Core/Hooks/useAppView'
import { FeatureFlagContext } from 'Core/FeatureFlagContext'
import Loader from 'Components/Loader'
import { useHistory } from 'react-router'
import { enqueueNotification, getCurrentOrg } from 'Utils/Helpers'
import { AppHeader, Typography } from 'procyon-ui'
import { useUser } from 'Core/Hooks/useUser'
import { LoadingFeedback, PingOneLogo, PingPrivilegeLogo } from 'V2Components'
import axios from 'axios'
import store from 'infra/redux/store'
import useMultiDispatch from 'Core/Hooks/useMultiDispatch'

const useStyles = makeStyles((theme) => ({
  root: {},
  appHeaderWrapper: {
    position: 'fixed',
    top: 0,
    width: '100vw',
    zIndex: 1500,
    borderBottom: 'var(--border-width) solid var(--color-border-base)',
    backgroundColor: 'var(--color-bg-base)'
  },
  logo: {
    '& img': {
      width: '125px'
    }
  }
}))

function Header({}) {
  const classes = useStyles()
  const history = useHistory()
  const { viewMode } = useAppView()
  const { selectDispatch } = useMultiDispatch(['tenantprofiles'])

  useEffect(() => {
    selectDispatch(['tenantprofiles'])
  }, [])
  // @ts-ignore
  const user = useSelector((state) => state.user)
  const tenantProfiles = Object.values(store.getState().tenantprofiles.map)
  const profile = tenantProfiles.find((e) => e.ObjectMeta.Name === user.ObjectMeta.Tenant)
  const [orgChanging, setOrgChanging] = useState(false)
  const [appViewChanging, setAppViewChanging] = useState(false)
  const { updateContext: asyncChangeAppView } = useContext(FeatureFlagContext)
  const nextViewMode = viewMode === 'admin' ? 'user' : 'admin'

  const { isAgentlessMode } = useUser()
  const copyID = (ID) => {
    try {
      navigator.clipboard.writeText(ID)
      enqueueNotification('Derived ID Copied!', 'info')
    } catch (error) {}
  }

  const switchViewMode = async () => {
    setAppViewChanging(true)
    await asyncChangeAppView(nextViewMode)
    setAppViewChanging(false)
  }

  const logoutUser = async () => {
    try {
      const hostName = window.location.host
      const updatedHost = hostName.replace('console.', '')

      const logoutURL = `https://console.login.${updatedHost}/logout`

      const response = await axios.get(logoutURL, {
        withCredentials: true
      })

      if (response && response.data) {
        window.location.href = response.data
      } else {
        console.error('Logout failed. Empty or invalid response.')
      }
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  const getHeaderMenuItems = () => {
    const items = []
    if (user.role === 'admin') {
      if (viewMode === 'admin')
        items.push({
          action: () => history.push('/admin/settings'),
          title: 'Settings'
        })
      items.push({
        action: switchViewMode,
        title: `Switch to ${nextViewMode}`
      })
    }

    if (viewMode === 'user') {
      // if (user?.Spec?.GCPDerivedID) {
      //   items.push({
      //     action: () => copyID(user?.Spec?.GCPDerivedID),
      //     title: `Copy GCP Derived ID`
      //   })
      // }
      if (user?.Spec?.AzureDerivedID) {
        items.push({
          action: () => copyID(user?.Spec?.AzureDerivedID),
          title: `Copy Azure Derived ID`
        })
      }
    }

    if (isAgentlessMode) {
      items.push({
        action: () => logoutUser(),
        title: 'Logout'
      })
    }

    return items
  }

  return (
    <div className={classes.root}>
      <div className={classes.appHeaderWrapper}>
        <AppHeader
          legacy={false}
          showNotificationBell={false}
          dropDownMenuItems={[...getHeaderMenuItems()]}
          BrandLogo={
            <div className='flex items-center justify-between gap-4'>
              <PingOneLogo className='!w-[150px]' />
              <PingPrivilegeLogo className='!w-[150px] mt-1' />
            </div>
          }
          className={classes.logo}
          userName={user.Spec.UserName ? user.Spec.UserName : user?.Spec?.ServerUserName}
          onClickNotificationButton={function noRefCheck() {}}
          // @ts-ignore
          userRole={
            <div className='flex items-center gap-1'>
              <Typography className='!text-gray-700' variant='bodySmall-regular'>
                <span className='capitalize'>{viewMode}</span>@
                <strong>{profile && profile.Spec?.TenantSpec?.EnvName}</strong>
              </Typography>
            </div>
          }
        />
      </div>
      <LoadingFeedback
        loading={orgChanging}
        caption='Please wait'
        message='Changing Organization'
      />
      <Loader loading={appViewChanging} />
    </div>
  )
}

export { Header }
